// extracted by mini-css-extract-plugin
export default {"about":"About_about__FAXt2","headline":"About_headline__fHbRo","detail":"About_detail__aih-u","body":"About_body__mju3i","facts":"About_facts__8dkEd","fact":"About_fact__nprXw"};